import { SVGProps } from "react";

export function IconClose(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.99944 0.764648C10.4137 0.764648 10.7494 1.10043 10.7494 1.51465V9.24993H18.4847C18.8989 9.24993 19.2347 9.58572 19.2347 9.99993C19.2347 10.4141 18.8989 10.7499 18.4847 10.7499L10.7494 10.7499L10.7494 18.4852C10.7494 18.8994 10.4137 19.2352 9.99944 19.2352C9.58523 19.2352 9.24944 18.8994 9.24944 18.4852L9.24944 10.7499H1.51416C1.09995 10.7499 0.76416 10.4141 0.76416 9.99993C0.76416 9.58571 1.09995 9.24993 1.51416 9.24993L9.24944 9.24993V1.51465C9.24944 1.10043 9.58523 0.764648 9.99944 0.764648Z"
        fill="#ffffff"
      />
    </svg>
  );
}
